import { useContext } from 'react';
import { RenderElementProps } from 'slate-react';
import { TagContext } from 'app/state/contexts/TagContext';

export const FootnoteElement = ({ attributes, children, element }: RenderElementProps) => {
  const { setSelectedFootnoteId } = useContext(TagContext) as any;

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setSelectedFootnoteId?.((element as any).footnoteId);
  };

  return (
    <span
      {...attributes}
      data-footnote-id={(element as any).footnoteId}
      onClick={handleClick}
      style={{
        backgroundColor: 'rgba(237, 137, 54, 0.16)',
        borderLeft: '2px solid rgba(237, 137, 54, 0.7)',
        borderRight: '2px solid rgba(237, 137, 54, 0.7)',
        borderRadius: '10px',
        cursor: 'pointer',
      }}
      title="Fotnot"
    >
      {children}
    </span>
  );
};
